import React from 'react'
import Modal from 'react-modal'

import AddItemToCollectionContainer from './collection/addItemToCollectionContainer'
import AddItemToCartContainer from './cart/addItemToCartContainer'
import SignInContainer from './user/signInContainer'
import SignUpContainer from './signup/signUpContainer'
import HostedMoreInfoContainer from './hosted/infoModal'

export default ({
  isModalOpen,
  closeModal,
  openModal,
  openModalType,
  openModalData
}) => {
  const renderModalContent = () => {
    switch (openModalType) {
      case 'addItemToCollection':
        return (
          <AddItemToCollectionContainer
            openModalData={openModalData}
            closeModal={closeModal}
          />
        )

      case 'addItemToCart':
        return <AddItemToCartContainer openModalData={openModalData} />

      case 'signIn':
        return (
          <SignInContainer
            openModal={openModal}
            closeModal={closeModal}
            openModalData={openModalData}
          />
        )

      case 'signUp':
        return <SignUpContainer closeModal={closeModal} />

      case 'hostedMoreInfo':
        return <HostedMoreInfoContainer closeModal={closeModal} />

      default:
        return null
    }
  }

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      {renderModalContent()}
    </Modal>
  )
}
